import { render, staticRenderFns } from "./notes-input.vue?vue&type=template&id=6421bb69"
import script from "./notes-input.vue?vue&type=script&lang=js"
export * from "./notes-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports